import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Flame, Heart, PlusSquare, MessageCircle, User } from "lucide-react";

const items = [
  { to: "/feed", label: "nav.feed", icon: Flame, testid: "nav-feed" },
  { to: "/dating", label: "nav.match", icon: Heart, testid: "nav-dating" },
  { to: "/post", label: "nav.post", icon: PlusSquare, testid: "nav-post", primary: true },
  { to: "/chats", label: "nav.chats", icon: MessageCircle, testid: "nav-chats" },
  { to: "/profile", label: "nav.you", icon: User, testid: "nav-profile" },
];

export const BottomNav = () => {
  const { t } = useTranslation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 h-[70px] bg-[#0B0F17]/85 backdrop-blur-xl border-t border-white/10 px-2 flex items-stretch justify-around"
    >
      {items.map(({ to, label, icon: Icon, testid, primary }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-mono uppercase tracking-widest ${
              isActive ? "text-rose-400" : "text-slate-500"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {primary ? (
                <span
                  className={`-mt-6 w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-to-br from-rose-500 to-amber-500 shadow-lg shadow-rose-500/40 transition-transform ${
                    isActive ? "scale-105" : ""
                  }`}
                >
                  <Icon size={26} className="text-white" strokeWidth={2.4} />
                </span>
              ) : (
                <Icon size={22} strokeWidth={isActive ? 2.6 : 2} />
              )}
              {!primary && <span className="mt-0.5">{t(label)}</span>}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
